export default function () {
    const schema = {};
    const $config = useRuntimeConfig().public;
    const $route = useRoute();

    schema.organization = {
        '@type': 'Organization',
        name: $config.siteName,
        logo: {
            '@type': 'ImageObject',
            url: $config.images + $config.siteEmailLogo,
        },
    };

    schema.build = function (data) {
        let textContent = {
            '@context': 'https://schema.org/',
            url: $config.base + $route.path,
            ...data,
        };
        return {
            key: 'jsonld',
            type: 'application/ld+json',
            textContent: JSON.stringify(textContent),
        };
    };

    return schema;
}
